import { IToastConfig } from 'src/common/primitives/Toast';

export function generateEditSuccessToast(
  id: number,
  entity: string
): IToastConfig {
  return {
    id,
    title: `${entity} updated successfully`,
  };
}
